import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlGeneral extends Layout {
    panelGeneralContent: Panel;
    sourceMCControl: DataSource;
    switchActive: Switch;
    switchCommunications: Switch;
    switchCompliment: Switch;
    switchDriverLogs: Switch;
    switchHOSData: Switch;
    switchImages: Switch;
    switchMobileDispatch: Switch;
    switchReeferTracking: Switch;
    switchTrailerTracking: Switch;
    textboxVendorId: Textbox;
    textboxVendorName: Textbox;
}
